import React, { useState, useEffect  } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import CreateAccountForm from './CreateAccountForm'
import Header from './parts/Header'
import Footer from '../after_login/parts/Footer'
import { Loader } from 'react-overlay-loader';
import 'react-overlay-loader/styles.css';

// CreateAccount
const CreateAccount = (props) => {

  let [loading, setLoading] = useState(false);
  let navigate = useNavigate();

  // componentDidMount
  useEffect(() => {

    if (window.location.hostname === "alphatest.shabelab.com") {
      navigate("/")
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return (

    <div>

      <div style={{
        backgroundColor: '#008CC8',
        height: 800,
      }}>


        {/* header */}
        <Header />

        {/* create account form */}
        <CreateAccountForm setLoading={setLoading} />

      </div>

      {/* fooder */}
      <Footer />

      {/* loading */}
      <Loader fullPage={true} loading={loading} />

    </div>
  )
}

export default CreateAccount
